import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setExercicioConsultaDespesasPorAcaoOrcamentaria: ['exercicio'],
    setAdministracaoConsultaDespesasPorAcaoOrcamentaria: ['administracao'],
    setOrgaosConsultaDespesasPorAcaoOrcamentaria: ['orgaos'],
    setRecursoConsultaDespesasPorAcaoOrcamentaria: ['recurso'],
    setDestinacaoConsultaDespesasPorAcaoOrcamentaria: ['destinacao'],
    limpaFiltroConsultaDespesasPorAcaoOrcamentaria: [],
    receberFiltroConsultaDespesasPorAcaoOrcamentaria: ['filtroRecebido'],
    setStatusConsultaDespesasPorAcaoOrcamentaria: ['status'],
})

const INITIAL_STATE = {
    exercicio: { value: new Date().getFullYear(), label: new Date().getFullYear() },
    administracao: [],
    orgaos: [],
    recurso: [],
    destinacao: [],
    status: { label: '', value: '' },
}

const setExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: action.exercicio }
}

const setAdministracao = (state = INITIAL_STATE, action) => {
    return { ...state, administracao: action.administracao }
}

const setOrgaos = (state = INITIAL_STATE, action) => {
    return { ...state, orgaos: action.orgaos }
}

const setRecurso = (state = INITIAL_STATE, action) => {
    return { ...state, recurso: action.recurso }
}

const setDestinacao = (state = INITIAL_STATE, action) => {
    return { ...state, destinacao: action.destinacao }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_EXERCICIO_CONSULTA_DESPESAS_POR_ACAO_ORCAMENTARIA]: setExercicio,
    [Types.SET_ADMINISTRACAO_CONSULTA_DESPESAS_POR_ACAO_ORCAMENTARIA]: setAdministracao,
    [Types.SET_ORGAOS_CONSULTA_DESPESAS_POR_ACAO_ORCAMENTARIA]: setOrgaos,
    [Types.SET_RECURSO_CONSULTA_DESPESAS_POR_ACAO_ORCAMENTARIA]: setRecurso,
    [Types.SET_DESTINACAO_CONSULTA_DESPESAS_POR_ACAO_ORCAMENTARIA]: setDestinacao,
    [Types.LIMPA_FILTRO_CONSULTA_DESPESAS_POR_ACAO_ORCAMENTARIA]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_DESPESAS_POR_ACAO_ORCAMENTARIA]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_DESPESAS_POR_ACAO_ORCAMENTARIA]: setStatus,
})
